(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1505],{

/***/ 41153:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/webinar-by-kc-admission-experts",
      function () {
        return __webpack_require__(6601);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_MetaTagsComp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47046);
/* harmony import */ var _components_PartnerWebinars__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83172);




const Webinars = (props)=>{
    const { meta  } = props.pageData;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#313145");
        customStyle.setProperty("--navbar-menu-color", "#ffffff");
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            meta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MetaTagsComp__WEBPACK_IMPORTED_MODULE_2__/* .MetaTagsComp */ .r, {
                ...meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PartnerWebinars__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Webinars);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,1539,8866,9774,2888,179], function() { return __webpack_exec__(41153); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);